// extracted by mini-css-extract-plugin
module.exports = {"root":"BidMaintenancePage_root__xk8dj","dialog":"BidMaintenancePage_dialog__2QjQR","submitButton":"BidMaintenancePage_submitButton__2Ljdj"};